(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-play/assets/javascripts/ball-row-play.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-play/assets/javascripts/ball-row-play.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.play = svs.tur.ball.row.play || {};
const Events = svs.tur.ball.constants,
  Animations = svs.tur.ball.row.play.animations.Core;
class Default extends svs.tur.Base {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    options.className = 'ball-row-play';
    super(options);
    this.log = new svs.core.log.Logger('ball.row.play');
    this.createDomElements();
    this.addEventListeners();
    this.valid = options.isValid;
    this.empty = options.isEmpty;
    this.active = options.isActive;
  }
  classNames() {
    return ['ball-row-play-default'];
  }
  createDomElements() {
    if (!this.isSystem) {
      this.$clearButton = this.row.createAndAddElement({
        className: 'btn-clear',
        appendTo: this.row.$inner
      });
      this.$clearButton.setAttribute('aria-label', 'Ta bort rad');
      const icon = document.createElement('div');
      icon.innerHTML = svs.ui.icon.partials.icon({
        icon: 'remove-sign',
        color: 'white',
        class: 'ball-row-clear-icon'
      });
      this.$clearIcon = icon.firstChild;
      this.$clearButton.appendChild(this.$clearIcon);
      this.row.$el.setAttribute('data-has-btn', 'true');
    }
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.$el.appendChild(this.row.render(visible));
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    this._hasRendered = true;
    return this.$el;
  }
  addEventListeners() {
    if (this.$clearButton) {
      this.$clearButton.addEventListener('click', () => {
        this.clearAll();
      });
    }
  }
  countVisibleNumbers() {
    let count = 0;
    this.row.balls.forEach(ball => {
      if (ball.number) {
        count++;
      }
    });
    return count;
  }
  getRandomBall() {
    const randomBallsWithNumber = this.row.balls.filter(ball => ball.number);
    return _.first(_.shuffle(randomBallsWithNumber));
  }
  showClearButton() {
    let duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.3;
    if (!this.$clearButton) return;
    const tl = gsap.timeline();
    tl.to(this.$clearButton, {
      duration: 0.1,
      autoAlpha: 1
    });
    tl.fromTo(this.$clearIcon, {
      duration,
      autoAlpha: 0,
      scale: 0.2,
      rotation: -720
    }, {
      duration: 0.3,
      autoAlpha: 1,
      scale: 1,
      rotation: 0
    });
    this.$clearIcon._visible = true;
  }
  hideClearButton() {
    let duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;
    if (!this.$clearButton) return;
    if (duration) {
      gsap.to(this.$clearButton, {
        duration,
        autoAlpha: 0
      });
      this.$clearIcon._visible = false;
    } else {
      gsap.set(this.$clearButton, {
        autoAlpha: 0
      });
      this.$clearIcon._visible = false;
    }
  }
  toggleClearButton(state, duration) {
    if (state) {
      this.showClearButton(duration);
    } else {
      this.hideClearButton(duration);
    }
  }
  getFirstAvailiableBall(extraNumber) {
    let availiableBall;
    const balls = this.row.balls;
    for (let i = 0; i < balls.length; i++) {
      if (!balls[i].number && Boolean(extraNumber) === Boolean(balls[i].extraNumber)) {
        availiableBall = balls[i];
        break;
      }
    }
    return availiableBall;
  }
  getAvailableBalls() {
    return {
      balls: this.row._regularBalls.filter(ball => !ball.number && !ball.extraNumber),
      extraBalls: this.row._extraBalls.filter(ball => !ball.number && ball.extraNumber)
    };
  }
  _changeBallCountComparison(level, extraNumbers) {
    const tl = gsap.timeline();
    const compareTo = extraNumbers ? this._extraNumbers : this._numbers;
    if (compareTo === level) {
      this.log.info("You cannot set the same level twice.");
    } else if (compareTo > level) {
      for (let j = compareTo - 1; j >= level; j--) {
        const ballTL = this.row.remove({
          index: j
        });
        tl.add(ballTL, '<.03');
      }
    } else if (compareTo < level) {
      const diff = level - compareTo;
      for (let i = 0; i < diff; i++) {
        const ballTL = this.row.add({
          empty: true,
          extraNumber: extraNumbers
        });
        tl.add(ballTL, i ? "-=".concat(ballTL.duration() * 0.8) : '');
      }
    }
    if (!extraNumbers) {
      this._numbers = level;
    } else {
      this._extraNumbers = level;
    }
    return tl;
  }
  changeBallCount(changeTo) {
    const tl = gsap.timeline();
    let count = 0;
    if (changeTo.numbers) {
      if (Array.isArray(changeTo.numbers)) {
        count = changeTo.numbers.length;
      } else {
        count = changeTo.numbers;
      }
      tl.add(this._changeBallCountComparison(count));
    }
    if (changeTo.extraNumbers) {
      if (Array.isArray(changeTo.extraNumbers)) {
        count = changeTo.extraNumbers.length;
      } else {
        count = changeTo.extraNumbers;
      }
      tl.add(this._changeBallCountComparison(count, true));
    }
    return tl;
  }
  prepare(obj) {
    this.huxfluxComplete();
    const tl = gsap.timeline();
    let rowPrepared = false;
    if (obj.numbers.length !== this._numbers || obj.extraNumbers && obj.extraNumbers.length !== this._extraNumbers) {
      tl.add(this.changeBallCount(obj));
    }
    obj.numbers.forEach((nr, i) => {
      const ball = this.row._regularBalls[i];
      if (ball && ball.number !== nr) {
        ball.prepare(nr);
        rowPrepared = true;
      }
    });
    if (obj.extraNumbers) {
      obj.extraNumbers.forEach((nr, i) => {
        const ball = this.row._extraBalls[i];
        if (ball && ball.number !== nr) {
          ball.prepare(nr);
          rowPrepared = true;
        }
      });
    }
    this.row._huxfluxPrepared = rowPrepared;
    tl.call(() => {
      tl.add(this.row.huxflux());
    });
    this._huxfluxTimeline = tl;
    return this._huxfluxTimeline;
  }
  huxfluxComplete() {
    if (this._huxfluxTimeline && this._huxfluxTimeline.isActive()) {
      this._huxfluxTimeline.progress(1);
    }
  }
  set active(state) {
    this._active = state;
    const duration = this._hasRendered ? 0.2 : 0;
    if (state) {
      this.trigger(Events.ROW_ACTIVE, this.row);
      this.addClass('ball-row-play-active');
      gsap.to(this.row.$inner, {
        duration,
        opacity: 1
      });
      if (this.row.winPlan) gsap.to(this.row.winPlan.$el, {
        duration,
        opacity: 1
      });
    } else {
      this.trigger(Events.ROW_INACTIVE, this.row);
      this.removeClass('ball-row-play-active');
      if (!this._valid) {
        gsap.to(this.row.$inner, {
          duration,
          opacity: 0.5
        });
        if (this.row.winPlan) gsap.to(this.row.winPlan.$el, {
          duration,
          opacity: 0.5
        });
      }
    }
  }
  get active() {
    return this._active;
  }
  set valid(state) {
    if (this._valid !== state) {
      this._valid = state;
      if (!this._valid && !this._active) {
        const duration = this._hasRendered ? 0.2 : 0;
        gsap.to(this.row.$inner, {
          duration,
          opacity: 0.5
        });
        if (this.row.winPlan) gsap.to(this.row.winPlan.$el, {
          duration,
          opacity: 0.5
        });
      } else if (this._valid) {
        const duration = this._hasRendered ? 0.2 : 0;
        gsap.to(this.row.$inner, {
          duration,
          opacity: 1
        });
        if (this.row.winPlan) gsap.to(this.row.winPlan.$el, {
          duration,
          opacity: 1
        });
      }
    }
  }
  set empty(state) {
    if (this._empty !== state) {
      this._empty = state;
      this.toggleClearButton(!state);
    }
  }
  next(_ref) {
    let number = _ref.number;
    const ballToUpdate = this.getFirstAvailiableBall();
    if (!ballToUpdate) {
      this.log.info('You cannot add anymore numbers to this row.');
      return false;
    }
    return Animations.update(ballToUpdate, number);
  }
  update(_ref2) {
    let _ref2$index = _ref2.index,
      index = _ref2$index === void 0 ? null : _ref2$index,
      _ref2$number = _ref2.number,
      number = _ref2$number === void 0 ? null : _ref2$number,
      to = _ref2.to,
      _ref2$extraNumber = _ref2.extraNumber,
      extraNumber = _ref2$extraNumber === void 0 ? false : _ref2$extraNumber;
    let updateBall;
    if (index === null && number === null) {
      updateBall = this.getFirstAvailiableBall(extraNumber);
    } else {
      updateBall = this.row.get({
        index,
        number,
        extraNumber
      });
    }
    if (updateBall) {
      const tl = gsap.timeline({
        onComplete: () => {
          this.trigger(Events.ROW_NUMBER_UPDATED, updateBall);
        }
      });
      if (to) {
        tl.add(Animations.update(updateBall, to));
      } else {
        tl.add(Animations.clear(updateBall));
      }
    } else {
      this.log.error("This index (".concat(index, ") does not exist"));
    }
  }
  add(_ref3) {
    let number = _ref3.number,
      index = _ref3.index,
      extraNumber = _ref3.extraNumber;
    const ball = this.row.spliceIn({
      number,
      index,
      extraNumber,
      replace: !this.isSystem
    });
    Animations.update(ball, number);
  }
  remove(_ref4) {
    let number = _ref4.number,
      index = _ref4.index,
      extraNumber = _ref4.extraNumber;
    this.row.spliceOut({
      number,
      index,
      extraNumber,
      replace: !this.isSystem
    });
  }
  addHuxfluxed(_ref5) {
    let number = _ref5.number,
      index = _ref5.index,
      extraNumber = _ref5.extraNumber;
    this.row.addHuxfluxed({
      number,
      index,
      extraNumber,
      replace: !this.isSystem
    });
  }
  clearAll() {
    if (!this.isSystem) {
      this.row.clear();
    } else {
      this.row.reset();
    }
  }
  animateIn() {
    this.row.rollIn();
  }
}
svs.tur.ball.row.play.Default = Default;

 })(window);